module.exports = __webpack_public_path__ + "fonts/558189fc-efd3-4d8f-aa5f-8ddaf391bf47.caaa1654.eot";